import { App } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

import { BarChart, LineChart, PieChart, RadarChart, GaugeChart,CustomChart   } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent, DataZoomComponent, GraphicComponent,TitleComponent } from 'echarts/components';
import Chart from './chart/index.vue';

import SvgIcon from './svgIcon/index.vue';
import YYMessage from './yy-message/index.vue';

use([
	CanvasRenderer,
	BarChart,
	LineChart,
	PieChart,
	RadarChart,
	GridComponent,
	TooltipComponent,
	LegendComponent,
	DataZoomComponent,
	GraphicComponent,
	TitleComponent,
	GaugeChart,
	CustomChart
]);

export default {
	install(Vue: App) {
		Vue.component('Chart', Chart);
		Vue.component('SvgIcon', SvgIcon);
		Vue.component('YYMessage', YYMessage);
	},
};
